// removed by extract-text-webpack-plugin
module.exports = {"outerWrapper":"xGupH0Xr7-vbZ7_ZZ_x5h","header":"_1SfyFEOlbhgiKHXS8ReriL","phone":"_3pUOz2U2HBZXMMCwsXZOPV"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Associations/extension-selection.css
// module id = 803
// module chunks = 0